export default __webpack_public_path__ + "assets/images/seven-hills-logo.png";